const React = require("react");

export const onClientEntry = () => {
  if (typeof window.IntersectionObserver === `undefined`) {
    require(`intersection-observer`);
  }
};

export const wrapPageElement = ({ element, props }) => {
  return <>{element}</>;
};
